import LuminisServiceUtils from "./utils/luminis-service-utils.es6.js";

const COOKIES = {
  LOGIN: 'myChartToken',
  COOKIES_JSR: 'cookiesjsr',
};

const WEBSITE_DOMAIN = 'luminishealth.org';

const SELECTORS = {
  LOGIN: '.field--name-field-primary-cta a',
  LOGOUT: '.field--name-field-mychart-logout-link a',
};

export const AUTHENTICATION_STATUS = {
  AUTHENTICATION_SUCCEEDED: 'AuthenticationSucceeded',
  AUTHENTICATION_FAILED: 'AuthenticationFailed',
  PASSWORD_EXPIRED: 'PasswordExpired',
};

export default class MyChartUser {
  constructor(patientId, myChartId, username, fullName) {
    this.patientId = patientId;
    this.myChartId = myChartId;
    this.username = username;
    this.firstName = fullName.split(' ')[0];
    this.fullName = fullName;
  }

  static async getLoggedInUser() {
    const luminisServiceUtils = new LuminisServiceUtils();
    const userJson = await luminisServiceUtils.getLoggedInUser()
    if (!userJson) return null; // Login cookie is invalid


    // TODO: LH-3072 - Remove auth header once oauth commited
    const token = MyChartUser.getLoginToken();
    if (!drupalSettings.feature_toggle.enabled.includes('oauth_mychart')) {
      if (!token) return null; // No login cookie present
    }

    return new MyChartUser(
      userJson.patientId,
      userJson.myChartId,
      userJson.myChartUsername,
      userJson.fullName,
    );
  }

  // TODO: LH-3072 - Remove auth header once oauth commited
  static login($, username, password, authenticationErrorHandler) {
    const path = document.querySelector(SELECTORS.LOGIN).href;

    $.ajax({
      type: 'POST',
      url: path,
      dataType: 'json',
      data: JSON.stringify({ username, password }),
      processData: false,
      contentType: 'application/json',
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
      },
      success(response) {
        if (response.result.success) {
          if (
            response.result.status ===
            AUTHENTICATION_STATUS.AUTHENTICATION_SUCCEEDED
          ) {
            MyChartUser.addLoginCookie(
              response.result.tokenInfo.token,
              response.result.tokenInfo.expiresAt,
            );

            MyChartUser.addMyChartSsoCookie(response.result.tokenInfo.token);
          } else {
            authenticationErrorHandler(response.result.status);
          }
        } else {
          authenticationErrorHandler(response.result.status);
        }
      },
      failure() {
        authenticationErrorHandler(AUTHENTICATION_STATUS.AUTHENTICATION_FAILED);
      },
    });
  }

  // TODO: LH-3072 - Remove auth header once oauth commited
  static addLoginCookie(token, expiresAt) {
    let cookie = `${COOKIES.LOGIN}=${token}; path=/; secure; expires=${new Date(
      expiresAt,
    ).toGMTString()}`;

    if (window.location.hostname.endsWith(WEBSITE_DOMAIN))
      cookie += `; domain=${WEBSITE_DOMAIN}`;

    document.cookie = cookie;
  }

  // TODO: LH-3072 - Remove auth header once oauth commited
  // Redirects the user to a page on the mychart.aahs.org domain that sets the MyChart SSO cookie from the same site to avoid any cross site cookie issues
  static addMyChartSsoCookie(token) {
    // check if "nextUrl" parameter is in url.
    const url = window.location;
    const urlObj = new URL(url);
    let nextUrl = urlObj.searchParams.get('nextUrl');

    if (!nextUrl) {
      if (
        document.referrer.indexOf(
          `${window.location.protocol}//${window.location.host}`,
        ) === 0
      ) {
        // Send to referring page only if the referring page is within LuminisHealth.org
        nextUrl = document.referrer;
      } else {
        // Send the user to the patient dashboard when they started on the login page.
        // This keeps the user from staying on the login page and being immediately logged out.
        nextUrl = document.querySelector(
          '.field--name-field-default-post-login-page a',
        ).href;
      }
    }

    const myChartSsoLoginRedirectLink = document.querySelector(
      '.field--name-field-mychart-sso-login-redirect a',
    ).href;

    window.location = `${myChartSsoLoginRedirectLink}?token=${token}&nextUrl=${encodeURIComponent(
      nextUrl,
    )}`;
  }


  static async logout() {
    MyChartUser.removeLoginCookie();

    const path = document.querySelector(SELECTORS.LOGOUT).href;

    await fetch(path, {
      method: 'POST',
      credentials: 'include',
    });

    MyChartUser.removeMyChartSsoCookie();
  }

  // TODO: LH-3072 - Remove auth header once oauth commited
  static removeLoginCookie() {
    const token = MyChartUser.getLoginToken();

    if (token) {
      let cookie = `${COOKIES.LOGIN}=; path=/; secure; expires=Thu, 01 Jan 1970 00:00:00 GMT`;

      if (window.location.hostname.endsWith(WEBSITE_DOMAIN))
        cookie += `; domain=${WEBSITE_DOMAIN}`;

      document.cookie = cookie;
    }
  }

  // TODO: LH-3072 - Remove auth header once oauth commited
  // Redirects the user to a page on the mychart.aahs.org domain that invalidated the MyChart SSO cookie from the same site to avoid any cross site cookie issues
  static removeMyChartSsoCookie() {
    const myChartSsoLogoutRedirectLink = document.querySelector(
      '.field--name-field-mychart-sso-logout-redirec a',
    ).href;

    window.location = `${myChartSsoLogoutRedirectLink}?nextUrl=${encodeURIComponent(
      window.location.href,
    )}`;
  }

  // TODO: LH-3072 - Remove auth header once oauth commited
  static getCookieValue(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
      return parts
        .pop()
        .split(';')
        .shift();
  }

  // TODO: LH-3072 - Remove auth header once oauth commited
  static getLoginToken() {
    return MyChartUser.getCookieValue('myChartToken');
  }
}

(() => {})(Drupal);
